
  import { defineComponent } from 'vue';

  import PageTitle from '@/common/components/redesigned/PageTitle.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import StatisticsPortalAverageVisitsTimeTabs from '../components/statistics/statistics-portal/StatisticsPortalAverageVisitsTimeTabs.vue';
  import StatisticsPortalEventsUsersTable from '../components/statistics/statistics-portal/StatisticsPortalEventsUsersTable.vue';
  import StatisticsPortalExportButtons from '../components/statistics/statistics-portal/StatisticsPortalExportButtons.vue';
  import StatisticsPortalFilter from '../components/statistics/statistics-portal/StatisticsPortalFilter.vue';
  import StatisticsPortalUniqueVisitsCountTab from '../components/statistics/statistics-portal/StatisticsPortalUniqueVisitsCountTab.vue';
  import StatisticsPortalViewsCountTabs from '../components/statistics/statistics-portal/StatisticsPortalViewsCountTabs.vue';
  import StatisticsPortalVisitsCountTabs from '../components/statistics/statistics-portal/StatisticsPortalVisitsCountTabs.vue';
  import { TStatisticsPortalFilter } from '../types/statistics/statistics-portal';

  const PERMISSIONS = {
    view: Constants.Permissions.AuditPortalStatisticView,
  };

  export default defineComponent({
    name: 'StatisticsPortal',
    components: {
      PageTitle,
      StatisticsPortalExportButtons,
      StatisticsPortalFilter,
      StatisticsPortalVisitsCountTabs,
      StatisticsPortalAverageVisitsTimeTabs,
      StatisticsPortalViewsCountTabs,
      StatisticsPortalUniqueVisitsCountTab,
      StatisticsPortalEventsUsersTable,
    },
    mixins: [security],
    data(): { filter: TStatisticsPortalFilter } {
      return {
        filter: {},
      };
    },
    created() {
      this.checkPermissionAndRedirect(PERMISSIONS.view);
    },
    methods: {
      searchFilter(newFilter: TStatisticsPortalFilter) {
        this.filter = newFilter;
      },
    },
  });
